export const DOB_AGE_RANGE = {
  MIN_AGE: 18,
  MAX_AGE: 105
};

export const EXCHANGE_DATE_RANGE = {
  MIN_DATE: 0,
  MAX_DATE: 1
};
